import React, {useEffect} from "react";
import { Routes, Route, useNavigate } from 'react-router-dom';
import { routes } from "./routes/index";

const App = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const User = localStorage.getItem('user') !== 'undefined' ? JSON.parse(localStorage.getItem('user')) : localStorage.clear();

        if (!User) navigate('/login');
    }, []);

  return (
      <Routes>
          {
              routes.map(({id, path, Component}) => (
                  <Route key={id} path={path} element={<Component/>} />
              ))
          }
      </Routes>
  );
}

export default App;
